"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var asg_1 = require("@alinta-digital/asg");
var AccountBalance_constants_1 = require("../AccountBalance.constants");
var formats_1 = require("../../../../utils/formats");
var DueDate = function (props) {
    var dueDate = props.dueDate, hasDirectDebitSetup = props.hasDirectDebitSetup, hasArrearsOnHoldSetup = props.hasArrearsOnHoldSetup;
    return (react_1.default.createElement(asg_1.Text, { size: "medium", "data-testid": "dueDateLabel", maxWidth: "119px", weight: 500, color: asg_1.colors['dark-7'] },
        hasArrearsOnHoldSetup ? AccountBalance_constants_1.AOH_DUE_DATE_LABEL : hasDirectDebitSetup ? AccountBalance_constants_1.DD_DUE_DATE_LABEL : AccountBalance_constants_1.DUE_DATE_LABEL,
        react_1.default.createElement(asg_1.Text, { size: "small", "data-testid": "dueDate", color: asg_1.colors['dark-7'] }, dueDate && (0, formats_1.formatDate)(dueDate))));
};
exports.default = DueDate;
//# sourceMappingURL=DueDate.js.map